module.exports = __webpack_public_path__ + "media/images/expandedMap-b436e517b409b854909784c773e15180.svg";